export default function (num) {
    // jacked from: https://github.com/sindresorhus/pretty-bytes
    if (typeof num !== 'number' || isNaN(num))
        throw new TypeError('Expected a number');
    let exponent;
    let unit;
    let neg = num < 0;
    let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    num = Math.abs(num);
    if (num < 1)
        return (neg ? '-' : '') + num + ' B';
    exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    let res = (num / Math.pow(1024, exponent)).toFixed(2);
    unit = units[exponent];
    return (neg ? '-' : '') + res + ' ' + unit;
}
;
